var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCorsi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M842.53,0H174.49C91.59,0,28.2,68.27,28.2,146.29v731.43c0,82.9,68.27,146.29,146.29,146.29h663.16c82.9,0,146.29-68.27,146.29-146.29h4.88V146.29C988.81,63.39,920.55,0,842.53,0ZM496.32,521.75c0,14.63-14.63,29.26-29.26,29.26-4.88,0-9.75,0-14.63-4.88l-102.4-68.27c-9.75-4.88-19.5-4.88-29.26,0l-112.15,73.14c-14.63,4.88-29.26,4.88-39.01-9.75-4.88-4.88-4.88-9.75-4.88-14.63V190.17c0-29.26,24.38-53.64,53.64-53.64h219.43c29.26,0,53.64,24.38,58.51,48.76v336.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCorsi);
export default __webpack_public_path__ + "static/media/menu-corsi.374e3e91cd80bac0fc1ab74c31f1e77c.svg";
export { ForwardRef as ReactComponent };